import { Container } from "./styles";

export function Skills() {
  return (
    <Container id="skills">
      <div className="about-text">
        <div>
          <h2>Skills</h2>
        </div>
        <div>
          <div className="skill-shape">
            <div style={{width:"80%"}} className="skill-shape-in">
              <div>smm</div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <div className="skill-shape">
            <div style={{width:"60%"}} className="skill-shape-in">
              <div>target</div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <div className="skill-shape">
            <div style={{width:"50%"}} className="skill-shape-in">
              <div>YouTube</div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <div className="skill-shape">
            <div style={{width:"45%"}} className="skill-shape-in">
              <div>Tik-tok</div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}
